/** The page's issue starts, newest first. An issue never seen healthy has no start: its `since` is only the first crawl. */
export const startsOf = (issues) =>
    [...new Set(issues.filter(({ sinceKind }) => sinceKind !== "neverHealthy").map(({ since }) => since))].sort().reverse();

/** The start the page opens on without `?since=`: the newest. */
export const defaultSinceOf = (issues) => startsOf(issues)[0] ?? null;

/** The issue's reading on one signal: sessions are read at the issue's top level, the others under their own key. */
export const readingOn = (issue, signal) => signal === "sessions"
    ? issue.lossCheck && { lossCheck: issue.lossCheck, lost: issue.trafficLost, rank: issue.rank }
    : issue[signal];

/** The days from `start` to `end`, both included. */
export const daysOf = ({ start, end }) => {
    const days = [];
    for (let day = start; day <= end; day = new Date(Date.parse(`${day}T00:00:00Z`) + 86400000).toISOString().slice(0, 10)) days.push(day);
    return days;
};

/** The days shown: `around` days either side of the issue start, or the whole window when there is none in it. */
export const daysAround = (days, since, around) => {
    const start = days.indexOf(since);
    return start < 0 ? days : days.slice(Math.max(0, start - around), start + around + 1);
};
